import format from 'date-fns/format';

// Calling val.toFixed(2) drops decimals down and creates a string
// representation of the number. If we then parse out the string into a float
// and call .toString() on that we can remove any 0s padded on at the end. I.e.
// '16.00` becomes '16'. Take that final string value and parse it back to a
// float and return.
export const trimDecimals = (val: number, decimals = 2): number =>
  parseFloat(parseFloat(val.toFixed(decimals)).toString());

// format percent and ensure at least 1 decimal place even if it is .0%
export const formatPercent = (val: number): string => {
  let percent = `${trimDecimals(parseFloat((val * 100).toString()))}`;
  if (percent.indexOf('.') === -1) {
    return `${percent}.0%`;
  }
  return `${percent}%`;
};

export const convertToUTC = (dateString: string) => {
  if (dateString.substr(dateString.length - 1) === 'Z') {
    return dateString;
  }

  return dateString + 'Z';
};

// Gets the localized date, without time
export const getLocalDate = (date: string) => format(new Date(date), 'P');

// Gets the localized date and time
export const getLocalDateTime = (dateTime: string) =>
  format(new Date(convertToUTC(dateTime)), "M/d/yyyy ' at ' h:mm a");

  // Gets the nonlocalized date and time
export const getNonLocalDateTime = (dateTime: string) =>
format(new Date(dateTime), "M/d/yyyy ' at ' h:mm a");


/**
 * @example stripMoneyFormat('$240,000') -> 240000
 * @example stripMoneyFormat('$240,k00') -> null
 */
export const stripMoneyFormat = (str: string): number | null => {
  // prettier-ignore
  const val = (str.includes(',') || str.includes('$')) 
    ? str.slice().replace(/[,$]/g, '')
    : str.slice();
  // Ensure the string can be a valid number
  if (isNaN(val as unknown as number)) {
    return null;
  }
  // Convert to number
  return +val;
};

export const getOrdinalNumber = (n: number) => {
  let s = ["th", "st", "nd", "rd"];
  let v = n % 100;
  return n + (s[(v-20)%10] || s[v] || s[0]);
}